



















































import Vue from 'vue';
import { EInputType } from '@/common/enums/frontpage.enum';
import { ICalendarDoor } from '@/common/interfaces/announcement-bar.interface';
import NewsletterForm from '@/components/frontpage/subcomponents/newslettersection/NewsletterForm.vue';
import { INewsletterFormData } from '@/common/interfaces/frontpage.interface';
import ChristmasCalendarButton
  from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarButton.vue';

interface IChristmasCalendarGiveawayDoorComponent {
  EInputType: typeof EInputType;
  isParticipantRegistered: boolean;
  registrationInProgress: boolean;
}

export default Vue.extend({
  name: `ChristmasCalendarGiveawayDoor`,
  components: { ChristmasCalendarButton, NewsletterForm },
  data(): IChristmasCalendarGiveawayDoorComponent {
    return {
      EInputType,
      isParticipantRegistered: false,
      registrationInProgress: false,
    };
  },
  props: {
    content: {
      required: true,
      type: Object as () => ICalendarDoor,
    },
    isDesktopView: {
      default: false,
      type: Boolean,
    },
    logoPath: {
      required: true,
      type: String,
    },
    showReadMore: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    navigateToOffers(): void {
      window.location.href = `/angebote/`;
    },
    async registerForGiveaway(data: INewsletterFormData): Promise<void> {
      this.registrationInProgress = true;
      const participantRegistered = await this.$zApiService.registerForGiveaway(data, this.content.calendarId, this.content.id);
      this.registrationInProgress = false;

      if(typeof participantRegistered === `boolean` && participantRegistered) {
        this.isParticipantRegistered = true;
        this.$swal({
          text: this.$t(`announcement-bar-ufe:calendar.giveaway.success.message`).toString(),
          title: this.$t(`announcement-bar-ufe:calendar.giveaway.success.headline`).toString(),
          type: `success`,
        });
      } else if(typeof participantRegistered === `string` && participantRegistered === `Participant is already registered for the giveaway`) {
        this.isParticipantRegistered = true;
        this.$swal({
          text: this.$t(`announcement-bar-ufe:calendar.giveaway.alreadyRegistered.message`).toString(),
          title: this.$t(`announcement-bar-ufe:calendar.giveaway.alreadyRegistered.headline`).toString(),
          type: `info`,
        });
      } else if(typeof participantRegistered === `string` && participantRegistered !== `database operation failed`) {
        this.$swal({
          text: participantRegistered,
          title: this.$t(`announcement-bar-ufe:calendar.giveaway.fail.headline`).toString(),
          type: `warning`,
        });
      } else {
        this.$swal({
          text: this.$t(`announcement-bar-ufe:calendar.giveaway.fail.message`).toString(),
          title: this.$t(`announcement-bar-ufe:calendar.giveaway.fail.headline`).toString(),
          type: `error`,
        });
      }
    },
  },
});
